import React, { useEffect, useState } from 'react'
import '../../Pages/Css/solicitudes.css'
import { formattedGlobalDate } from '../../utils/formattedDates'

const getSolicitudStatus = (solicitud) => {
    if (solicitud.estado === 'Solicitud Cliente por Confirmar') {
        return { key: 'progress', label: 'Por confirmar' };
    }
    if (!solicitud.Hora) return { key: 'neutral', label: 'Sin hora programada' };

    const raw = String(solicitud.Hora).trim();
    const plainMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);
    const horaCitaMs = plainMatch
        ? Date.UTC(Number(plainMatch[1]), Number(plainMatch[2]) - 1, Number(plainMatch[3]), Number(plainMatch[4]), Number(plainMatch[5]), Number(plainMatch[6] || '00'))
        : Date.parse(raw);

    if (Number.isNaN(horaCitaMs)) return { key: 'neutral', label: 'Sin hora programada' };
    const diferencia = (Date.now() - horaCitaMs) / 1000 / 60;
    if (diferencia >= 0) return { key: 'expired', label: 'Vencida' };
    if (diferencia >= -120) return { key: 'review', label: 'Próximas 2 h' };
    if (diferencia >= -240) return { key: 'approved', label: 'Próximas 2-4 h' };
    return { key: 'neutral', label: 'Más de 4 h' };
};

const SolicitudesResponsive = (props) => {
    const [expandedCards, setExpandedCards] = useState({});

    const toggleDetails = (id) => {
        setExpandedCards((current) => ({ ...current, [id]: !current[id] }));
    };

    useEffect(() => {
        // console.log("solcitudes filtradas", props.filteredSolicitudes);
        // console.log("solcitudes list:", props.listSolicitudes);
    }, [props]);

    return (
        <div className='containerCardsSolicitudes'>
            {props.filteredSolicitudes && props.filteredSolicitudes.map((solicitud, index) => (
                <article key={solicitud.IDSolicitudes || index} className={`cardSolicitudesInitial solicitud-status-${getSolicitudStatus(solicitud).key}`}>
                    <div className='header'>
                        <div>
                            <p><strong>{solicitud.IDSolicitudes}</strong></p>
                            <span className='solicitud-status-badge'><i aria-hidden='true' />{getSolicitudStatus(solicitud).label}</span>
                        </div>
                        <div className='opcionesSolicitud'>
                            <button type='button' aria-label='Editar solicitud' title='Editar solicitud' onClick={() => props.showModalUpdateSolicitud(solicitud.IDSolicitudes)}><i className='bx bxs-pencil' /></button>
                            <button type='button' aria-label='Agregar reporte' title='Agregar reporte' onClick={() => props.showModalAddReport(solicitud.IDSolicitudes)}><i className='bx bxs-plus-square' /></button>
                            <button type='button' aria-label='Anular solicitud' title='Anular solicitud' onClick={() => props.showModalCausal(solicitud.IDSolicitudes)}><i className='bx bx-trash' /></button>
                        </div>
                    </div>
                    <div className='body'>
                        <p><i className='bx bxs-business' aria-hidden='true' /><strong>Empresa:</strong><span>{solicitud.NombreEmpresa || '—'}</span></p>
                        <p><i className='bx bx-map-alt' aria-hidden='true' /><strong>Ruta:</strong><span>{solicitud.Ruta || '—'}</span></p>
                        <p><i className='bx bxs-truck' aria-hidden='true' /><strong>Placa:</strong><span>{solicitud.PlacaTruck || '—'}</span></p>
                        <p><i className='bx bx-map' aria-hidden='true' /><strong>#Contenedor:</strong><span>{solicitud.Contenedor || '—'}</span></p>
                        <p><i className='bx bx-phone' aria-hidden='true' /><strong>Contacto:</strong><span>{solicitud.Contacto || '—'}</span></p>
                        <p><i className='bx bxs-user' aria-hidden='true' /><strong>Instalador:</strong><span>{solicitud.NombreInstalador || '—'}</span></p>
                        <p><i className='bx bx-user' aria-hidden='true' /><strong>Nombre:</strong><span>{solicitud.NombreConductor || 'Sin registro'}</span></p>
                        <p><i className='bx bx-phone-call' aria-hidden='true' /><strong>Celular:</strong><span>{solicitud.MovilConductor || 'Sin registro'}</span></p>
                    </div>
                    {expandedCards[solicitud.IDSolicitudes] && (
                        <div className='solicitud-extra-details'>
                            <p><strong>Hora del servicio:</strong><span>{solicitud.Hora ? formattedGlobalDate(solicitud.Hora) : 'Sin hora programada'}</span></p>
                            <p><strong>Nota:</strong><span>{solicitud.nota || 'Sin nota'}</span></p>
                            <p><strong>Última nota:</strong><span>{solicitud.hora_e ? formattedGlobalDate(solicitud.hora_e) : 'Sin registro'}</span></p>
                        </div>
                    )}
                    <div className='card-footer'>
                        <button type='button' onClick={() => toggleDetails(solicitud.IDSolicitudes)} aria-expanded={Boolean(expandedCards[solicitud.IDSolicitudes])}>
                            <i className={`bx ${expandedCards[solicitud.IDSolicitudes] ? 'bx-chevron-up' : 'bx-chevron-down'}`} />
                            {expandedCards[solicitud.IDSolicitudes] ? 'Ver menos detalles' : 'Ver más detalles'}
                        </button>
                        <span><i className='bx bx-time-five' /> {formattedGlobalDate(solicitud.hora_e || solicitud.Hora)}</span>
                    </div>
                </article>
            ))}
        </div>
    )
}

export default SolicitudesResponsive
